import type { TypedModel } from './dva-types.js';

const model: TypedModel<readonly never[]> = {
  namespace: 'result',
  state: [],
  reducers: {},
  effects: {},
};

export default model;
